import React from "react";
import api from "../../hooks/api";
import { API_URLS } from "../../App";
import ErrorMessage from "../common/ErrorMessage";
import SuccessMessage from "../common/SuccessMessage";

const CheckUser = ({
  setError,
  setSuccess,
}: {
  setError: (message: string | null) => void;
  setSuccess: (message: string | null) => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [loginRequest, setLoginRequest] = React.useState<{
    username: string;
    password: string;
  }>({
    username: "",
    password: "",
  });
  const [userInfo, setUserInfo] = React.useState<CheckUser | null>(null);

  const validateUser = async () => {
    if (!loginRequest.username || !loginRequest.password) {
      setError("Por favor, preencha todos os campos.");
      return;
    }
    setError(null);
    setSuccess(null);
    setLoading(true);
    api
      .post(API_URLS.USERS + "_actions/check_username", loginRequest)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data as CheckUser;
          console.log("User validation successful:", data);
          setUserInfo(data);
          setSuccess("Utilizador validado com sucesso.");
        } else {
          setError("Erro ao validar o utilizador. Por favor, tente novamente.");
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {
        setError("Erro ao validar o utilizador. Por favor, tente novamente.");
        console.warn("Error validating user:", error);
        // Handle error here
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      <div className="container">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            validateUser();
          }}
        >
          <div className="box model-card mt-10">
            <p className="text-2xl font-bold mb-4">
              Validar credenciais de utilizador
            </p>
            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label" htmlFor="username">
                    Nome de Utilizador
                  </label>
                  <div className="control is-expanded">
                    <input
                      type="text"
                      placeholder="Introduza o nome de utilizador"
                      className="input"
                      autoFocus
                      onChange={(e) =>
                        setLoginRequest({
                          ...loginRequest,
                          username: e.target.value,
                        })
                      }
                      value={loginRequest.username}
                      required
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          loginRequest.username &&
                          loginRequest.password
                        ) {
                          e.preventDefault();
                          validateUser();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label" htmlFor="password">
                    Palavra-passe
                  </label>
                  <div className="control is-expanded">
                    <input
                      id="password"
                      type="password"
                      placeholder="Introduza a palavra-passe"
                      className="input"
                      onChange={(e) =>
                        setLoginRequest({
                          ...loginRequest,
                          password: e.target.value,
                        })
                      }
                      value={loginRequest.password}
                      required
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          loginRequest.username &&
                          loginRequest.password
                        ) {
                          e.preventDefault();
                          validateUser();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="control">
              <button className="button is-primary is-fullwidth">
                Validar
              </button>
            </div>
          </div>
        </form>
        {loading && (
          <div className="box model-card mt-10">
            <div className="loading-spinner"></div>
            <p>A validar utilizador...</p>
          </div>
        )}
        {userInfo && (
          <div className="box model-card mt-10">
            <p className="text-xl font-bold mb-2">Informações do Utilizador</p>
            <p>
              <strong>Nome de Utilizador:</strong> {userInfo.username}
            </p>
            <p>
              <strong>
                Password válida:{" "}
                <span
                  className={
                    userInfo.is_password_valid
                      ? "has-text-success"
                      : "has-text-danger"
                  }
                >
                  {" "}
                  {userInfo.is_password_valid ? "Sim" : "Não"}
                </span>
              </strong>
            </p>
            <details className="mt-2" open={true}>
              <summary>Detalhes</summary>
              <ul>
                <li>
                  <strong>Existe na BD:</strong>{" "}
                  {userInfo.user_exists_in_db ? "Sim" : "Não"}
                </li>
                <li>
                  <strong>Criado em:</strong>{" "}
                  {userInfo.user_created_at ?? "N/A"}
                </li>
                <li>
                  <strong>Já migrado:</strong>{" "}
                  {userInfo.already_migrated ? "Sim" : "Não"}
                </li>
                <li>
                  <strong>Utilizador ativo:</strong>{" "}
                  {userInfo.is_active_user ? "Sim" : "Não"}
                </li>
                <li className="mt-4">
                  <strong>Existe no Orimat:</strong>{" "}
                  {userInfo.user_exists_in_orimat ? "Sim" : "Não"}
                </li>
                <li>
                  <strong>Password legacy válida:</strong>{" "}
                  {userInfo.is_legacy_password ? "Sim" : "Não"}
                </li>
                <li>
                  <strong>Utilizador Orimat ativo:</strong>{" "}
                  {userInfo.is_active_orimat_user ? "Sim" : "Não"}
                </li>
                {userInfo.user_exists_in_orimat && (
                  <>
                    <li className="mt-4">
                      <strong>Nome no Orimat:</strong>{" "}
                      {userInfo.name_on_orimat ?? "N/A"}
                    </li>
                    <li>
                      <strong>Email no Orimat:</strong>{" "}
                      {userInfo.email_on_orimat ?? "N/A"}
                    </li>
                    <li>
                      <strong>Telefone no Orimat:</strong>{" "}
                      {userInfo.phone_on_orimat ?? "N/A"}
                    </li>
                  </>
                )}
              </ul>
            </details>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckUser;
